export default "__VITE_ASSET__CvdwY40w__"